export interface Advisor {
  id: string;
  name: string;
  title: string;
  avatar: string;
  phone: string;
  email: string;
  whatsapp: string;
  languages: string[];
  slaResponse: string;
  specialties: string[];
}

export const mockAdvisor: Advisor = {
  id: 'adv1',
  name: 'Sarah Chen',
  title: 'Senior Financial Advisor',
  avatar: 'https://i.pravatar.cc/150?img=47',
  phone: '+852 9123 4567',
  email: 'sarah.chen@aia.com.hk',
  whatsapp: '+852 9123 4567',
  languages: ['English', 'Cantonese', 'Mandarin'],
  slaResponse: 'Within 2 hours',
  specialties: ['Life Insurance', 'Health Coverage', 'Family Planning', 'Retirement'],
};

export interface Message {
  id: string;
  sender: 'user' | 'advisor' | 'system';
  content: string;
  timestamp: string;
  read: boolean;
}

export const mockMessages: Message[] = [
  {
    id: 'm1',
    sender: 'advisor',
    content: "Hi! I'm Sarah, your AIA advisor. How can I help you today?",
    timestamp: '2025-11-02T10:00:00Z',
    read: true,
  },
  {
    id: 'm2',
    sender: 'user',
    content: 'I have some questions about maternity coverage',
    timestamp: '2025-11-02T10:15:00Z',
    read: true,
  },
  {
    id: 'm3',
    sender: 'advisor',
    content:
      "Great! Your AIA policy includes comprehensive maternity coverage. Let me know what specific areas you'd like to discuss.",
    timestamp: '2025-11-02T10:17:00Z',
    read: true,
  },
  {
    id: 'm4',
    sender: 'user',
    content: 'What about coverage for ultrasounds and prenatal checkups?',
    timestamp: '2025-11-02T10:20:00Z',
    read: true,
  },
  {
    id: 'm5',
    sender: 'advisor',
    content:
      'Your plan covers up to 8 prenatal checkups and 3 ultrasound scans per pregnancy at 100% within our network. Would you like me to send you the detailed benefits guide?',
    timestamp: '2025-11-02T10:22:00Z',
    read: false,
  },
];

export interface QuickReply {
  id: string;
  label: string;
  action: string;
}

export const mockQuickReplies: QuickReply[] = [
  {
    id: 'qr1',
    label: 'Request a call',
    action: 'request_call',
  },
  {
    id: 'qr2',
    label: 'Ask about education plan',
    action: 'education_plan',
  },
  {
    id: 'qr3',
    label: 'Send documents',
    action: 'send_documents',
  },
  {
    id: 'qr4',
    label: 'Schedule appointment',
    action: 'schedule_appointment',
  },
];
